import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { SpinLoading } from "antd-mobile";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { footerHeight } from "../components/PageFooter";
import PagePanelFooter from "../components/PagePanelFooter";
import { WalletInfo, WalletRouterBlock } from "../../components/Wallet";
import { useStores } from "../../models";
import walletBg from "../../assets/images/user/wallet_top_BG.png";

const ScrollArea = styled.div`
  height: calc(100% - ${footerHeight} - ${headerHeight});
  overflow: auto;
  background: #f7f8ff;
  position: relative;
`;
const Bg = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 220px;
  background: url(${walletBg}) top center / cover no-repeat;
  z-index: 0;
`;
const Content = styled.div`
  position: relative;
  z-index: 1;
  padding-top: 8px;
`;

const Wallet = () => {
  const { walletStore, bankStore } = useStores();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        await Promise.all([
          walletStore.getWalletInfo(),
          walletStore.loadPaymentList(),
          bankStore.getBankList(),
        ]);
      } finally {
        setIsLoading(false);
      }
    };
    init();
  }, [walletStore, bankStore]);

  return (
    <PageWrap>
      <PageHeader title="我的钱包" isBackButton={false} />
      <ScrollArea>
        <Bg />
        <Content>
          {isLoading ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
              <SpinLoading /> 载入钱包资讯中
            </div>
          ) : (
            <>
              <WalletInfo
                pay_pwd={!!walletStore?.pay_pwd}
                is_id_verify={!!walletStore?.is_id_verify}
                is_phone_verify={!!walletStore?.is_phone_verify}
                credit_score={walletStore?.credit_score || 0}
                balance={walletStore?.balance || 0}
                realName={walletStore?.realName || ""}
              />
              <WalletRouterBlock
                pay_pwd={!!walletStore?.pay_pwd}
                is_id_verify={!!walletStore?.is_id_verify}
                is_phone_verify={!!walletStore?.is_phone_verify}
                credit_score={walletStore?.credit_score || 0}
                balance={walletStore?.balance || 0}
                realName={walletStore?.realName || ""}
              />
            </>
          )}
        </Content>
      </ScrollArea>
      <PagePanelFooter />
    </PageWrap>
  );
};

export default observer(Wallet);
